/********************************************************************************
Filename: np-breakpoint-container.js
Created: 05 Apr 2021
Author: Ron Robertson
Description: Sets a max width depending on the breakpoint.Centers content.

Usage example:
    <np-breakpoint-container>
        My content here
    </np-breakpoint-container>
********************************************************************************/

(function() {
    const template = document.createElement('template');

    template.innerHTML = `
        <style>
            #np-breakpoint-container{
                width: var(--content-width);
                margin:0 auto;
            }


            /* XLarge */
            @media screen and (min-width: 1200px) {
                :host(.indent) #np-breakpoint-container {
                    width: calc((var(--col-width) * 10) + (var(--gutter-width) * 9));
                }
            }

            @media screen and (min-width: 1920px) {
                :host(.indent) #np-breakpoint-container {
                    max-width: 955px;
                }
            }
        </style>

        <div id="np-breakpoint-container">
            <slot></slot>
        </div><!--END np-breakpoint-container-->
    `;

    class NpBreakpointContainer extends HTMLElement {
      constructor() {

        /* Always call super first in constructor */
        super();

        /* Activate the Shadow DOM */
        this.attachShadow({mode: 'open'});

        /* Attach template to DOM */
        this.shadowRoot.appendChild(template.content.cloneNode(true));

      } /* END constructor */


    } /* END class */

    /* Export the class */
    window.customElements.define('np-breakpoint-container', NpBreakpointContainer);

  })();
